import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import { setTitle } from "../../redux/titleSlice";
import { Link, useParams } from "react-router-dom";
import apiClient from '../../services/apiClient';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

const EditForm = React.forwardRef((props, ref) => {
  const [showDynamicContent1, setShowDynamicContent1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [title2, settitle2] = useState("Type your question here");
  const [placeholder2, setplaceholder2] = useState("Type Placeholder here");
  const [addedoptions, setaddedoptions] = useState([
    { listpotion: "option" },
    { listpotion: "option" },
  ]);
  const [question, setQuestion] = useState([]);
  const [popup, setpopup] = useState(false);
  const navigate = useNavigate();

  const { QuestionnairesId } = useParams();

  const ref2 = useRef(null);

  const handleInput1 = (e, index) => {
    if (ref2.current) {
      ref2.current.style.height = "auto";
      ref2.current.style.height = `${e.target.scrollHeight + 16}px`;
    }
  };

  const ref3 = useRef([]);

  const handleInput = (e, index) => {
    if (ref3.current[index]) {
      ref3.current[index].style.height = "auto";
      ref3.current[index].style.height = `${e.target.scrollHeight + 16}px`;
    }
  };

  const ref4 = useRef([]);

  const handleInput2 = (e, index) => {
    if (ref4.current[index]) {
      ref4.current[index].style.height = "auto";
      ref4.current[index].style.height = `${e.target.scrollHeight + 16}px`;
    }
  };

  const changecls = (e, index, optionid) => {
    const updatedquestion = [...question];
    updatedquestion[index].option[optionid].listpotion = e.target.value;
    setQuestion(updatedquestion);
  };

  const preview = () => {
    setpopup(true);
  };

  const handleplaceholder = (e, index) => {
    const updatedquestion = [...question];
    updatedquestion[index].placeholder = e.target.value;
    setQuestion(updatedquestion);
  };

  const handleplaceholder2 = (e, index) => {
    const updatedquestion = [...question];
    updatedquestion[index].placeholder2 = e.target.value;
    setQuestion(updatedquestion);
  };

  const handleplaceholderChange = (e) => {
    setplaceholder2(e.target.value);
  };
  const deleteoptions = (index, indexoption) => {
    const updatedoptionquestion = [...question[index].option];
    updatedoptionquestion.splice(indexoption, 1);
    const updatedquestion = [...question];
    updatedquestion[index].option = updatedoptionquestion;
    setQuestion(updatedquestion);
  };

  const addmoreoptions = (index) => {
    const updatedoptionquestion = [
      ...question[index].option,
      { listpotion: "option" },
    ];
    const updatedquestion = [...question];
    updatedquestion[index].option = updatedoptionquestion;
    setQuestion(updatedquestion);
  };

  const newRef = useRef([]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  });

  React.useEffect(() => {
    var ele = document.getElementById("preview1");
    if (ele != null) {
      document.getElementById("preview1").addEventListener("click", preview);
    }
  }, []);

  const handleOutsideClick = (e) => {
    question.map((ev, indexw) => {
      if (
        newRef.current[indexw] &&
        !newRef.current[indexw].contains(e.target)
      ) {
        const updatedquestion = [...question];
        updatedquestion[indexw].optionadd = false;
        setQuestion(updatedquestion);
      } else {
      }
    });
  };

  const addoption = (index) => {
    const updatedquestion = [...question];
    updatedquestion[index].optionadd = true;
    setQuestion(updatedquestion);
    setaddedoptions(updatedquestion[index].option);
  };

  const handleToggleContent1 = (e) => {
    e.stopPropagation();
    setShowDynamicContent1((prevState) => !prevState);
    //setShowDynamicContent2(false); // Close other dynamic content if open
    // alert("dhirendra");
  };

  const handleTitleChange = (e) => {
    settitle2(e.target.value);
  };
  const handleTitleClick = (e) => {
    e.preventDefault();
    setIsEditing2(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useImperativeHandle(ref, () => ({
    getQuestion: () => {
      return question;
    },
    getTitle2: () => {
      return title2;
    },
    getPlaceholder2: () => {
      return placeholder2;
    },
  }), [question, title2, placeholder2]);

  const addfields = (typeadd, index) => {
    const newquestion = {
      type: typeadd,
      showServiceInfo: false,
      ques: "Type your question here",
      ques2: "Type your question here",
      placeholder: "Type placeholder here",
      placeholder2: "Type placeholder here",
      option: [{ listpotion: "option" }, { listpotion: "option" }],
      optionadd: false,
    };
    if (index >= 0) {
      toggleHandleServiceInfo(index);
      const newData = question.slice(0);
      newData.splice(index + 1, 0, newquestion);
      setQuestion(newData);
    } else {
      setShowDynamicContent1((prevState) => !prevState);
      const newData = question.slice(0);
      newData.splice(0, 0, newquestion);
      setQuestion(newData);
    }
  };

  const deletequestion = (index) => {
    const updatedquestion = [...question];
    updatedquestion.splice(index, 1);
    setQuestion(updatedquestion);
  };

  const toggleHandleServiceInfo = (index) => {
    const updatedquestion = [...question];
    updatedquestion[index].showServiceInfo =
      !updatedquestion[index].showServiceInfo;
    setQuestion(updatedquestion);
  };

  const handlequestion = (e, index) => {
    const updatedquestion = [...question];
    updatedquestion[index].ques = e.target.value;
    setQuestion(updatedquestion);
  };

  const handlequestion2 = (e, index) => {
    const updatedquestion = [...question];
    updatedquestion[index].ques2 = e.target.value;
    setQuestion(updatedquestion);
  };

  const closepopup = () => {
    setpopup(false);
  };

  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        const response = await apiClient.get(
          `/questionnaires/${QuestionnairesId}`
        );
        // setContractContent(response.data.pages[0].content);
        // setinvoicetitle(response.data.title);
        settitle2(response.data.question1);
        setplaceholder2(response.data.placeholder1);
        response.data.question.forEach((tabs1, index) => {
          //count++;
          //  const newTabTitle = tabs1.page_name;

          const newTab = {
            type: tabs1.type,
            showServiceInfo: tabs1.showServiceInfo == 1 || tabs1.showServiceInfo === true,
            ques: tabs1.ques,
            ques2: tabs1.ques2,
            placeholder: tabs1.placeholder,
            placeholder2: tabs1.placeholder2,
            option: JSON.parse(tabs1.options),
            optionadd: tabs1.optionadd == 1 || tabs1.optionadd === true,
          };
          setQuestion((question) => [...question, newTab]);

          // Use functional update for setTabs to ensure latest state
        });

        // setinvoiceitem(response.data.invoice_item);

        // setinvoicepayments(response.data.invoice_payment);


        // dispatch(setTitle(response.data.title));


        // setContractCount(response.data.question__pages.length+1);
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchQuestionnaires();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      ref3.current.forEach((el) => {
        if (el) {
          el.style.height = "auto";
          el.style.height = `${el.scrollHeight + 16}px`;
        }
      });
      ref4.current.forEach((el) => {
        if (el) {
          el.style.height = "auto";
          el.style.height = `${el.scrollHeight + 16}px`;
        }
      });
    }, 0);
  }, [question]);

  return (
    <>
      {popup && (
        <div className="previewpart">
          <div className="headerpreview">
            You're now previewing this as a client.Feel free to play
            around,nothing will be sent! &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            <button
              id="submit-btn"
              type="button"
              className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
              onClick={closepopup}
            >
              EXIT PREVIEW
            </button>
          </div>

          <div className="gap">&nbsp;</div>

          <div className="midlepart">
            <div className="gap">&nbsp;</div>
            <div className="gap">&nbsp;</div>

            {/*  <div className="formelement">
                                              <label htmlFor='name' className='form-label mt-0'>
                                                  {title2}
                                                </label>
                                                <input
                                                  type='text'
                                                  className='form-control'
                                                  id='name'
                                                  name='name'
                                                  placeholder={placeholder2}
                                                />
                                </div>

                                */}

            {question.map((tab, index) => (
              <div
                className="col-12 teet left"
                key={index}
                ref={(element) => {
                  newRef.current[index] = element;
                }}
              >
                <div className="mb-3 form_input">
                  {tab?.type != "twofields" &&
                    tab?.type != "2ColumnText" &&
                    tab?.type != "FullwidthText" && (
                      <>
                        {" "}
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.ques}
                        </label>{" "}
                      </>
                    )}

                  {tab?.type == "FullwidthText" && (
                    <div className="col-md-12 d-flex center">
                      <div className="col-md-12 centre">
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.placeholder}
                        </label>
                      </div>
                    </div>
                  )}

                  {tab?.type == "2ColumnText" && (
                    <div className="col-md-12 d-flex center">
                      <div className="col-md-6 margin ">
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.placeholder}
                        </label>
                      </div>
                      <div className="col-md-6 margin">
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.placeholder2}
                        </label>
                      </div>
                    </div>
                  )}

                  {tab?.type == "twofields" && (
                    <div className="col-md-12 d-flex">
                      <div className="col-md-6 margin left ">
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.ques}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder={tab.placeholder}
                        />
                      </div>
                      <div className="col-md-6 margin left">
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.ques2}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder={tab.placeholder2}
                        />
                      </div>
                    </div>
                  )}

                  {tab?.type == "shorttext" && (
                    <div className="col-md-12 d-flex ">
                      <div className="col-md-12 left">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder={tab.placeholder}
                        />
                      </div>
                    </div>
                  )}

                  {/* long text part start  */}
                  {tab?.type == "longtext" && (
                    <div className="col-md-12 d-flex left">
                      <div className="col-md-12 left">
                        <textarea
                          placeholder={tab.placeholder}
                          rows={1}
                          cols="50"
                          className="textare1"
                        />
                      </div>
                    </div>
                  )}

                  {/* long text part end  */}

                  {/* long text part start  */}
                  {tab?.type == "Dropdown" && (
                    <>
                      {" "}
                      {!tab.optionadd ? (
                        <div className="col-md-12 left">
                          {" "}
                          <div className="col-md-12 left">
                            <select className="selectfull">
                              {tab.option.map((optiontab, index2) => (
                                <option>{optiontab.listpotion} </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  {/* long text part end  */}

                  {/* Single choice part start  */}
                  {tab?.type == "Singlechoice" && (
                    <>
                      <div className="col-md-12 mb-10">
                        {tab.option.map((optiontab, index2) => (
                          <div className="col-md-12 gapbetween">
                            <div className="col-md-10">
                              <input
                                type="radio"
                                id={optiontab.listpotion}
                                name="fav_language"
                                value={optiontab.listpotion}
                              />
                               {" "}
                              <label for={optiontab.listpotion}>
                                {optiontab.listpotion}{" "}
                              </label>
                              <br />
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Single choice part end  */}

                  {/* Multichoice choice part start  */}
                  {tab?.type == "Multichoice" && (
                    <>
                      {" "}
                      <div className="col-md-12 mb-10">
                        {tab.option.map((optiontab, index2) => (
                          <div className="col-md-12">
                            <input
                              type="checkbox"
                              id={index2}
                              name="fav_language"
                              value={optiontab.listpotion}
                            />
                             {" "}
                            <label for={index2}>{optiontab.listpotion} </label>
                            <br />
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Multichoice choice part end  */}

                  {/* Multichoice choice part start  */}
                  {tab?.type == "DatePicker" && (
                    <div className="col-md-12 d-flex left">
                      <div className="col-md-12">
                        <input type="date" className="datetype" />
                      </div>
                    </div>
                  )}

                  {/* Multichoice choice part end  */}
                </div>
              </div>
            ))}

            <div className="gap2">&nbsp;</div>
          </div>

          <div className="gap">&nbsp;</div>

          <div className="nextbtn">
            {" "}
            <button
              id="submit-btn"
              type="button"
              className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
              onClick={closepopup}
            >
              NEXT
            </button>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* Full Name Field */}
          <div className="col-12">
            <div className="mb-3 form_input" onClick={handleTitleClick}>
              {/*  {isEditing2 ? (
                 <textarea ref={ref2}  placeholder='Enter a description' rows={1}  onInput={handleInput1}  className="textareq"
                 onChange={handleTitleChange}  
                 value={title2} 
               />
              ) : (
                <label htmlFor='name' className='form-label mt-0'>
                        {title2}
                  </label>
              )}

            
            <input
              type='text'
              className='form-control'
              id='name'
              name='name'
              onChange={handleplaceholderChange}
              placeholder={placeholder2}
            />    */}

              {/* add button */}
              <div className="plus_btn" onClick={handleToggleContent1}>
                <i className="fa fa-plus"></i>
              </div>

              {/* dynamic content part*/}
              <div
                className={`dynamic-content-container ${
                  showDynamicContent1 ? "visible" : ""
                }`}
              >
                <div className="content-header py-4">
                  <div className="position-relative">
                    <h4>Select the type of block you’d like to add:</h4>
                    <button
                      className="removeBoxBtn"
                      onClick={() => setShowDynamicContent1(false)}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>

                  {/* Tab button area */}
                  <ul
                    className="nav nav-pills mb-3 justify-content-center mt-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                      >
                        QUESTIONS
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="false"
                      >
                        CONTENT
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Tab content area */}
                <div className="tab-content mt-4 pb-5 " id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    {/* Content Tab */}
                    <div className="row gy-4">
                      {/* Full width box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("twofields", -1)}
                      >
                        {" "}
                        <div className="content-box centre ">
                          <img src="/img/twofield.png" alt="skeleton" />
                          <h4 className="mt-2">Two fields</h4>
                        </div>
                      </div>
                      {/*2 column text box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("shorttext", -1)}
                      >
                        {" "}
                        <div className="content-box column-text centre ">
                          <img src="/img/shorttext.png" alt="skeleton" />
                          <h4 className="mt-2">Short Text</h4>
                        </div>
                      </div>

                      {/*2 column Image box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("longtext", -1)}
                      >
                        {" "}
                        <div className="content-box   centre">
                          <img src="/img/longtext.png" alt="skeleton" />
                          <h4 className="mt-2">Long Text</h4>
                        </div>
                      </div>
                      {/*2 cover Image box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("Dropdown", -1)}
                      >
                        {" "}
                        <div className="content-box   centre">
                          <img src="/img/dropduon.png" alt="skeleton" />
                          <h4 className="mt-2">Dropdown</h4>
                        </div>
                      </div>

                      {/*2 cover Image box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("Singlechoice", -1)}
                      >
                        {" "}
                        <div className="content-box   centre">
                          <img src="/img/single.png" alt="skeleton" />
                          <h4 className="mt-2">Single choice</h4>
                        </div>
                      </div>

                      {/*2 cover Image box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("Multichoice", -1)}
                      >
                        {" "}
                        <div className="content-box   centre">
                          <img src="/img/multiple.png" alt="skeleton" />
                          <h4 className="mt-2">Multi choice blue</h4>
                        </div>
                      </div>

                      {/*2 cover Image box */}
                      <div
                        className="col-6 col-md-6 col-lg-4"
                        onClick={() => addfields("DatePicker", -1)}
                      >
                        {" "}
                        <div className="content-box   centre">
                          <img src="/img/datepicker.png" alt="skeleton" />
                          <h4 className="mt-2">Date Picker</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Question Tab Content */}
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="row gy-4">
                      {/* Two fields */}
                      <div
                        className="col-6 col-md-4 col-lg-4"
                        onClick={() => addfields("FullwidthText", -1)}
                      >
                        {" "}
                        <div className="content-box shortText ">
                          <div className="item_box bg-white d-flex align-items-center shadow-lg justify-content-center">
                            <div className="row gap-2 d-flex align-items-center m-2">
                              <div className="skeleton-box ">
                                <div className="skeleton-one"></div>
                              </div>
                            </div>
                          </div>
                          <h4 className="mt-2">Full Width Text</h4>
                        </div>
                      </div>
                      {/* Short text fields */}
                      <div
                        className="col-6 col-md-4 col-lg-4"
                        onClick={() => addfields("2ColumnText", -1)}
                      >
                        {" "}
                        <div className="content-box twoFields">
                          <div className="item_box bg-white d-flex align-items-center shadow-lg justify-content-center">
                            <div className="row gap-2 d-flex align-items-center m-2">
                              <div className="skeleton-box">
                                <div className=" skeleton-one"></div>
                              </div>
                              <div className="skeleton-box">
                                <div className="skeleton-one"></div>
                              </div>
                            </div>
                          </div>
                          <h4 className="mt-2">2 Column Text</h4>
                        </div>
                      </div>

                      {/*Date Picker box */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* What type of event are you looking for? Field */}

          {question.map((tab, index) => (
            <div
              className="col-12 teet"
              key={index}
              ref={(element) => {
                newRef.current[index] = element;
              }}
            >
              <div className="mb-3 form_input" onClick={handleTitleClick}>
                {tab?.type != "twofields" &&
                  tab?.type != "2ColumnText" &&
                  tab?.type != "FullwidthText" && (
                    <>
                      {isEditing2 ? (
                        <textarea
                          ref={(el) => (ref3.current[index] = el)}
                          placeholder="Enter a description"
                          rows={1}
                          onInput={(e) => handleInput(e, index)}
                          className="textareq"
                          onChange={(e) => handlequestion(e, index)}
                          value={tab.ques}
                        />
                      ) : (
                        <label htmlFor="name" className="form-label mt-0">
                          {tab.ques}
                        </label>
                      )}
                    </>
                  )}

                {tab?.type == "twofields" && (
                  <div className="col-md-12 d-block  d-md-flex center col-sm-12 ">
                    <div className="col-md-6 col-sm-12 margin ">
                      <textarea
                        ref={(el) => (ref3.current[index] = el)}
                        placeholder="Enter a description"
                        rows={1}
                        onInput={(e) => handleInput(e, index)}
                        className="textareq"
                        onChange={(e) => handlequestion(e, index)}
                        value={tab.ques}
                      />
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder={tab.placeholder}
                        onChange={(e) => handleplaceholder(e, index)}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 margin m-top ">
                      <textarea
                        ref={(el) => (ref4.current[index] = el)}
                        placeholder="Enter a description"
                        rows={1}
                        onInput={(e) => handleInput2(e, index)}
                        className="textareq"
                        onChange={(e) => handlequestion2(e, index)}
                        value={tab.ques2}
                      />

                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder={tab.placeholder2}
                        onChange={(e) => handleplaceholder2(e, index)}
                      />
                    </div>
                  </div>
                )}

                {tab?.type == "shorttext" && (
                  <div className="col-md-12 d-flex center">
                    <div className="col-md-12 centre">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder={tab.placeholder}
                        onChange={(e) => handleplaceholder(e, index)}
                      />
                    </div>
                  </div>
                )}

                {tab?.type == "FullwidthText" && (
                  <div className="col-md-12 d-flex center">
                    <div className="col-md-12 centre">
                      <textarea
                        ref={(el) => (ref3.current[index] = el)}
                        placeholder={tab.placeholder}
                        rows={1}
                        onInput={(e) => handleInput(e, index)}
                        className="textareq"
                        onChange={(e) => handleplaceholder(e, index)}
                      />
                    </div>
                  </div>
                )}

                {tab?.type == "2ColumnText" && (
                  <div className="col-md-12 d-flex center">
                    <div className="col-md-6 margin ">
                      <textarea
                        ref={(el) => (ref3.current[index] = el)}
                        placeholder={tab.placeholder}
                        rows={1}
                        onInput={(e) => handleInput(e, index)}
                        className="textareq"
                        onChange={(e) => handleplaceholder(e, index)}
                      />
                    </div>
                    <div className="col-md-6 margin">
                      <textarea
                        ref={(el) => (ref4.current[index] = el)}
                        placeholder={tab.placeholder2}
                        rows={1}
                        onInput={(e) => handleInput2(e, index)}
                        className="textareq"
                        onChange={(e) => handleplaceholder2(e, index)}
                      />
                    </div>
                  </div>
                )}

                {/* long text part start  */}
                {tab?.type == "longtext" && (
                  <div className="col-md-12 d-flex center">
                    <div className="col-md-12 centre">
                      <textarea
                        rows={1}
                        cols="50"
                        value={tab.placeholder}
                        onChange={(e) => handleplaceholder(e, index)}
                        className="textare1"
                      />
                    </div>
                  </div>
                )}

                {/* long text part end  */}

                {/* long text part start  */}
                {tab?.type == "Dropdown" && (
                  <>
                    {" "}
                    {!tab.optionadd ? (
                      <div className="col-md-12  center">
                        {" "}
                        <div className="col-md-12 centre">
                          <select className="selectfull">
                            {tab.option.map((optiontab, index2) => (
                              <option>{optiontab.listpotion} </option>
                            ))}
                          </select>
                        </div>{" "}
                        <div
                          className="col-md-12 left edit_option"
                          onClick={() => addoption(index)}
                        >
                          <i class="fa fa-pencil" aria-hidden="true"></i>&nbsp;
                          Edit option list
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-12 mb-10">
                        {tab.option.map((optiontab, index2) => (
                          <div className="col-md-12">
                            <input
                              type="text"
                              placeholder="Option"
                              value={optiontab.listpotion}
                              className="optioncls"
                              onChange={(e) => changecls(e, index, index2)}
                            />
                          </div>
                        ))}

                        <div
                          className="col-md-12 left edit_option"
                          onClick={() => addmoreoptions(index)}
                        >
                          <i className="fa fa-plus plussize"></i> Add option
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* long text part end  */}

                {/* Single choice part start  */}
                {tab?.type == "Singlechoice" && (
                  <>
                    <div className="col-md-12 mb-10">
                      {tab.option.map((optiontab, index2) => (
                        <div className="col-md-12 gapbetween">
                          <div className="col-md-10">
                            <span className="round">&nbsp;</span>
                            {optiontab.listpotion.length > 50 ? (
                              <textarea
                                value={optiontab.listpotion}
                                className="optioncls2"
                                onChange={(e) => {
                                  changecls(e, index, index2);
                                }}
                                onInput={(e) => {
                                  e.target.style.height = "auto"; // reset
                                  e.target.style.height =
                                    e.target.scrollHeight + "px"; // set new height
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                value={optiontab.listpotion}
                                className="optioncls2"
                                onChange={(e) => changecls(e, index, index2)}
                              />
                            )}
                          </div>
                          <div
                            className="col-md-2 alignright"
                            onClick={() => deleteoptions(index, index2)}
                          >
                            {" "}
                            <i className="fa fa-trash"></i>{" "}
                          </div>
                        </div>
                      ))}
                      <div
                        className="col-md-12 left edit_option"
                        onClick={() => addmoreoptions(index)}
                      >
                        <i className="fa fa-plus plussize"></i> Add option
                      </div>
                    </div>
                  </>
                )}

                {/* Single choice part end  */}

                {/* Multichoice choice part start  */}
                {tab?.type == "Multichoice" && (
                  <>
                    {" "}
                    <div className="col-md-12 mb-10">
                      {tab.option.map((optiontab, index2) => (
                        <div className="col-md-12 gapbetween">
                          <div className="col-md-10">
                            <span className="round2">&nbsp;</span>
                            {optiontab.listpotion &&
                            optiontab.listpotion.length > 50 ? (
                              <textarea
                                placeholder="Option"
                                value={optiontab.listpotion}
                                className="optioncls2"
                                onChange={(e) => {
                                  changecls(e, index, index2);
                                }}
                                onInput={(e) => {
                                  e.target.style.height = "auto"; // reset
                                  e.target.style.height =
                                    e.target.scrollHeight + "px"; // set new height
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                placeholder="Option"
                                value={optiontab.listpotion}
                                className="optioncls2"
                                onChange={(e) => changecls(e, index, index2)}
                              />
                            )}
                          </div>
                          <div
                            className="col-md-2 alignright"
                            onClick={() => deleteoptions(index, index2)}
                          >
                            {" "}
                            <i className="fa fa-trash"></i>{" "}
                          </div>
                        </div>
                      ))}

                      <div
                        className="col-md-12 left edit_option"
                        onClick={() => addmoreoptions(index)}
                      >
                        <i className="fa fa-plus plussize"></i> Add option
                      </div>
                    </div>
                  </>
                )}

                {/* Multichoice choice part end  */}

                {/* Multichoice choice part start  */}
                {tab?.type == "DatePicker" && (
                  <div className="col-md-12 d-flex center">
                    <div className="col-md-12">
                      <input type="date" className="datetype" />
                    </div>
                  </div>
                )}

                {/* Multichoice choice part end  */}

                {/* add button */}
                <div
                  className="plus_btn"
                  onClick={() => toggleHandleServiceInfo(index)}
                >
                  <i className="fa fa-plus"></i>
                </div>

                <div
                  className="delete_btn"
                  onClick={() => deletequestion(index)}
                >
                  <i className="fa fa-trash"></i>
                </div>

                {/* dynamic content part*/}
                <div
                  className={`dynamic-content-container ${
                    tab.showServiceInfo ? "visible" : ""
                  }`}
                >
                  <div className="content-header py-4">
                    <div className="position-relative">
                      <h4>Select the type of block you’d like to add:</h4>
                      <button
                        className="removeBoxBtn"
                        onClick={() => toggleHandleServiceInfo(index)}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>

                    {/* Tab button area */}
                    <ul
                      className="nav nav-pills mb-3 justify-content-center mt-3"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target={`#pills-home-${index}`}
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          QUESTIONS
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target={`#pills-profile-${index}`}
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          CONTENT
                        </button>
                      </li>
                    </ul>
                  </div>

                  {/* Tab content area */}
                  <div className="tab-content mt-4 pb-5 " id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id={`pills-home-${index}`}
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      {/* Content Tab */}
                      <div className="row gy-4">
                        {/* Full width box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("twofields", index)}
                        >
                          {" "}
                          <div className="content-box centre ">
                            <img src="/img/twofield.png" alt="skeleton" />
                            <h4 className="mt-2">Two fields</h4>
                          </div>
                        </div>
                        {/*2 column text box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("shorttext", index)}
                        >
                          {" "}
                          <div className="content-box column-text centre ">
                            <img src="/img/shorttext.png" alt="skeleton" />
                            <h4 className="mt-2">Short Text</h4>
                          </div>
                        </div>

                        {/*2 column Image box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("longtext", index)}
                        >
                          {" "}
                          <div className="content-box   centre">
                            <img src="/img/longtext.png" alt="skeleton" />
                            <h4 className="mt-2">Long Text</h4>
                          </div>
                        </div>
                        {/*2 cover Image box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("Dropdown", index)}
                        >
                          {" "}
                          <div className="content-box centre">
                            <img src="/img/dropduon.png" alt="skeleton" />
                            <h4 className="mt-2">Dropdown</h4>
                          </div>
                        </div>

                        {/*2 cover Image box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("Singlechoice", index)}
                        >
                          {" "}
                          <div className="content-box centre">
                            <img src="/img/single.png" alt="skeleton" />
                            <h4 className="mt-2">Single choice</h4>
                          </div>
                        </div>

                        {/*2 cover Image box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("Multichoice", index)}
                        >
                          {" "}
                          <div className="content-box   centre">
                            <img src="/img/multiple.png" alt="skeleton" />
                            <h4 className="mt-2">Multi choice blue</h4>
                          </div>
                        </div>

                        {/*2 cover Image box */}
                        <div
                          className="col-6 col-md-6 col-lg-4"
                          onClick={() => addfields("DatePicker", index)}
                        >
                          {" "}
                          <div className="content-box centre">
                            <img src="/img/datepicker.png" alt="skeleton" />
                            <h4 className="mt-2">Date Picker</h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Question Tab Content */}
                    <div
                      className="tab-pane fade"
                      id={`pills-profile-${index}`}
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <div className="row gy-4">
                        {/* Two fields */}
                        <div
                          className="col-6 col-md-4 col-lg-4"
                          onClick={() => addfields("FullwidthText", index)}
                        >
                          {" "}
                          <div className="content-box shortText">
                            <div className="item_box bg-white d-flex align-items-center shadow-lg justify-content-center">
                              <div className="row gap-2 d-flex align-items-center m-2">
                                <div className="skeleton-box ">
                                  <div className="skeleton-one"></div>
                                </div>
                              </div>
                            </div>
                            <h4 className="mt-2">Full width Text</h4>
                          </div>
                        </div>
                        {/* Short text fields */}
                        <div
                          className="col-6 col-md-4 col-lg-4"
                          onClick={() => addfields("2ColumnText", index)}
                        >
                          {" "}
                          <div className="content-box twoFields ">
                            <div className="item_box bg-white d-flex align-items-center shadow-lg justify-content-center">
                              <div className="row gap-2 d-flex align-items-center m-2">
                                <div className="skeleton-box">
                                  <div className=" skeleton-one"></div>
                                </div>
                                <div className="skeleton-box">
                                  <div className="skeleton-one"></div>
                                </div>
                              </div>
                            </div>
                            <h4 className="mt-2">2 Column Text </h4>
                          </div>
                        </div>

                        {/*Date Picker box */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </form>{" "}
    </>
  );
});

export default React.memo(EditForm);
